 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import A2_FM_MOBI from '@/components/02_FM_mobi'
 import A3_INTRO_MOBI from '@/components/03_INTRO_mobi'
 import A4_CUBA_MOBI from '@/components/04_CUBA_mobi'
 import A5_MEXICO_MOBI from '@/components/05_MEXICO_mobi'
 import A6_NICARAGUA_MOBI from '@/components/06_NICARAGUA_mobi'
 import A7_COSTA_RICA_MOBI from '@/components/07_COSTA_RICA_mobi'
 import A8_PANAMA_MOBI from '@/components/08_PANAMA_mobi'
 import A9_ECUADOR_MOBI from '@/components/09_ECUADOR_mobi'
 import A0_PERU_MOBI from '@/components/10_PERU_mobi'
 import A1_CHILE_MOBI from '@/components/11_CHILE_mobi'
 import A2_BM_MOBI from '@/components/12_BM_mobi'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/02_FM_mobi",
 			"name" : "02_FM_mobi",
 			"component" : A2_FM_MOBI
 		},
 		{
 			"path" : "/03_INTRO_mobi",
 			"name" : "03_INTRO_mobi",
 			"component" : A3_INTRO_MOBI
 		},
 		{
 			"path" : "/04_CUBA_mobi",
 			"name" : "04_CUBA_mobi",
 			"component" : A4_CUBA_MOBI
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js